import script from "./RegisterStudyClinician.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterStudyClinician.vue?vue&type=script&setup=true&lang=js"

import "./RegisterStudyClinician.vue?vue&type=style&index=0&id=2424ea05&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2424ea05"]])

export default __exports__